import 'url-polyfill';
import dva from 'dva';

import createHistory from 'history/createHashHistory';
import createLoading from 'dva-loading';

import enter from './enter';

import 'moment/locale/zh-cn';
import '@music/adbiz-react-components/dist/index.css';

// import './rollbar';
import './g2';
import './index.less';

// 1. Initialize
const history = createHistory()
const app = dva({ history })

// 2. Plugins
app.use(createLoading());

// 3. Register global model
app.model(require('./models/global').default);

// 4. Router
app.router(require('./router').default);

// Clear history state when refresh page
if (typeof (window) !== 'undefined') {
  window.addEventListener('beforeunload', () => window.history.replaceState(null, undefined));
}

// 5. Start
enter(history).then(() => app.start('#root'))

export default app._store; // eslint-disable-line

